import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListStakeholdersQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Stakeholder',
  props: {
    iroId: {
      type: String,
      required: true
    },
    stakeholderIds: {
      type: Array,
      required: true
    }
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;
    var _useListStakeholdersQ = useListStakeholdersQuery({
        filters: {
          iroIds: [props.iroId]
        }
      }),
      result = _useListStakeholdersQ.result,
      refetch = _useListStakeholdersQ.refetch;
    var stakeholderItems = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listStakeholders.map(function (stakeholder) {
        return {
          text: stakeholder.name,
          value: stakeholder.id
        };
      });
    });
    expose({
      refetch: refetch
    });
    return {
      __sfc: true,
      props: props,
      result: result,
      refetch: refetch,
      stakeholderItems: stakeholderItems
    };
  }
});